/* ••[1]••••••••••••••••••••••••• LocalTipsProvider.ts •••••••••••••••••••••••••••••• */

import LocalProvider from "./LocalProvider";

import SelectItem from "../../../interfaces/SelectItem";

import Tag from "../../../interfaces/Tag";
import { VanillaDiscussion } from "../../../interfaces/VanillaApi";
import FetchSettings from "../../../interfaces/FetchSettings";
import { getMode } from "../../../utilities";

export default class LocalTipsProvider extends LocalProvider {
  async getCategoryTags(catId: number): Promise<Array<SelectItem>> {
    const parentTag = await this.getTags(["query=Category " + catId]);
    return parentTag.length > 0
      ? this.getTags(["parentID=" + parentTag[0].id])
      : [];
  }

  public async getTips(tag: Tag, limit = 5): Promise<Array<VanillaDiscussion>> {
    //community.oracle.com/ccc/api/v2/tags?query=Tip&parentID=133
    const url = new URL(this.baseUrl + "search");
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const searchParams = new URLSearchParams();
    searchParams.append("page", "1");
    searchParams.append("limit", limit.toString());
    // searchParams.append("sort", "-dateInserted");
    searchParams.append("recordTypes[]", "discussion");
    // searchParams.append("types[]", "discussion");
    searchParams.append("tags[]", tag.urlCode);
    searchParams.append("tagOperator", "and");
    url.search = new URLSearchParams(searchParams).toString();
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    return await this.request(url.toString(), settings);
  }

  async lookupForTipTag(parentTagId: number): Promise<Tag | null> {
    return {
      id: 24,
      name: "Tips",
      urlCode: parentTagId + "-tips",
    };
  }
}
